(ns frontend.view.login.mfa
  (:require [reagent.core :as r]
            [common.localization :as loc]
            [frontend.view.login.events :as events]
            [frontend.view.login.components.common :as common]
            [frontend.view.login.db :as db]
            [frontend.whitelabelling.utils :as wu]
            [frontend.bootstrap.components :as rbs]
            [ui.components.button.view :as button]
            [ui.components.alert.view :as alert]))

(defn mfa-view []
  (let [mfa-data (:mfa-data @db/state)
        mfa-error? (:mfa-error? @db/state)
        {:keys [role-id account-id tenant-id tenant-name target-id]} mfa-data]
    [:div
     [:div
      (when mfa-error?
        [alert/danger
         {:on-close    events/hide-mfa-error!}
         (loc/tr :mfa-does-not-match)])]
     [rbs/Form
      {:on-submit  (fn [e]
                     (.preventDefault e)
                     (events/set-tenant-with-mfa! target-id account-id role-id tenant-id (:mfa @db/state)))
       :class-name "login-form-section mt-md-5 pt-md-5"}
      [common/form-group {:control-id "login-mfa"
                          :label      (str (loc/tr :mfa-code) ":")
                          :type       "text"
                          :value      (:mfa @db/state)
                          :on-change! (partial events/on-change! :mfa)}]
      [rbs/FormGroup
       [button/primary-solid
        {:type       "submit"
         :size       ""
         :block      true
         :class "mt-3"}
        (loc/tr :submit)]]]
     [:div]]))
